<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
import { useRegisterValidation } from "@/components/EditorValidator";
const props = defineProps<EditControlProps>();
const emitFn = defineEmits<CommonEditControlEmits>();

let type: string = "text"; // email und passwort gibt es auch

let clearable = ref<boolean>(false);
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
const uiData = reactive(ui);
config.validate = validate;
useRegisterValidation({ config });

onMounted(() => {
  mounted(uiData, props, config);
});

function textChanged() {
  valueChanged(config, uiData, uiData.data);
}

function validate() {
  if (uiData.disabled) {
    uiData.errorText = "";
    return true;
  } // disabled Controls sind IMMER valide ;)
  if (uiData.required) {
    if (uiData.data) {
      uiData.errorText = "";
      return true;
    }
    uiData.errorText = config.requiredMessage;
    return false;
  }
  uiData.errorText = "";
  return true;
}
</script>
<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      v-model="uiData.showtooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
      :disabled="!uiData.showtooltip || !uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          v-bind="props"
          id="textbox"
          :clearable="clearable"
          :label="uiData.description"
          :disabled="uiData.disabled"
          v-model="uiData.data"
          @update:modelValue="textChanged"
          ref="textfield"
          :error-messages="uiData.errorText"
          :required="uiData.required"
          variant="outlined"
          density="compact"
          color="warning"
          persistent-hint
        ></v-text-field>
        <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        />
      </template>
    </v-tooltip>
  </div>
</template>
<style scoped>
.warning {
  -webkit-text-fill-color: red;
}

.v-text-field input {
  font-size: 13px;
}
</style>
